import { render } from "./ExternalLaborCostsDetails.vue?vue&type=template&id=5e919022&scoped=true"
import script from "./ExternalLaborCostsDetails.vue?vue&type=script&lang=js"
export * from "./ExternalLaborCostsDetails.vue?vue&type=script&lang=js"

import "./ExternalLaborCostsDetails.vue?vue&type=style&index=0&id=5e919022&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/DBCapacity-VUE/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e919022"]])

export default __exports__